module.exports = __webpack_public_path__ + "static/img/wxa-bind-page.75f3c37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/wxa-bind-page.jpg
// module id = m0vO
// module chunks = 4